// @flow
const Elm = require('./src/ResponsePreviewSetupApp.elm').Elm;
document.addEventListener('DOMContentLoaded', () => {
  const previewSetupTrigger = document.getElementById(
    'response_preview_setup_trigger'
  );

  const node = document.querySelector(
    '[data-elm-embedded-app=response-preview-setup]'
  );

  const setupPorts = (ports) => {
    const displayApp = () => {
      ports.displayApp.send(null);
      if (previewSetupTrigger) {
        previewSetupTrigger.removeEventListener('click', displayApp);
      }
    };

    if (previewSetupTrigger) {
      previewSetupTrigger.addEventListener('click', displayApp);
    }

    ports.closeApp.subscribe(() => {
      if (previewSetupTrigger) {
        previewSetupTrigger.addEventListener('click', displayApp);
      }
    });
  };

  if (node && previewSetupTrigger) {
    const rawFlags = node.getAttribute('data-elm-flags');
    const flags = rawFlags ? JSON.parse(rawFlags) : {};
    /*
    Elm takes over and mutates the embedded elm node, removing the flag data. In order to remove the
    elm app from the DOM and reinitialize with initial data on a HAML page we are nesting the elm
    element inside the element with the flags. This allows the elm element to be initalized/removed
    from DOM keeping the flags intact ready for reinitialize.
    */
    const app = Elm.ResponsePreviewSetupApp.init({ node, flags });
    setupPorts(app.ports);
  }
});

// TODO Delete contents of embedded elm app when modal closes
